export default "__VITE_ASSET__BNZk7BL$__"